import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getFaqDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  faq: [
    {
      fieldName: "FAQs Order Sequence",
      fieldValue: "field_order_sequence",
      className: "col-span-6",
      type: "text",
      name: "field_order_sequence",
      formType: "number",
      label: "FAQs Order Sequence",
      placeholder: "Enter FAQs Order Sequence",
      validation: { required: "FAQs Order Sequence is required" },
    },
    {
      fieldName: "FAQs Question (EN)",
      fieldValue: "field_faqs_question",
      className: "col-span-6",
      type: "text",
      name: "field_faqs_question",
      formType: "input",
      label: "FAQs Question (EN)",
      placeholder: "Enter FAQs question (EN)",
      validation: { required: "FAQs Question (EN) is required" },
    },
    {
      fieldName: "FAQs Question (MS)",
      fieldValue: "field_malay_faqs_question",
      className: "col-span-6",
      type: "text",
      name: "field_malay_faqs_question",
      formType: "input",
      label: "FAQs Question (MS)",
      placeholder: "Enter FAQs Question (MS)",
      // validation: { required: "FAQs Question (MS) is required" },
    },
    {
      fieldName: "FAQs Question (ZH)",
      fieldValue: "field_mandarin_faqs_question",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_faqs_question",
      formType: "input",
      label: "FAQs Question (ZH)",
      placeholder: "Enter FAQs Question (ZH)",
      // validation: { required: "FAQs Question (ZH) is required" },
    },
    {
      fieldName: "FAQs Answer (EN)",
      fieldValue: "field_faqs_answer",
      className: "col-span-6",
      type: "text",
      name: "field_faqs_answer",
      formType: "input",
      label: "FAQs Answer (EN)",
      placeholder: "Enter FAQs answer (EN)",
      validation: { required: "FAQs Answer (EN) is required" },
    },
    {
      fieldName: "FAQs Answer (MS)",
      fieldValue: "field_malay_faqs_answer",
      className: "col-span-6",
      type: "text",
      name: "field_malay_faqs_answer",
      formType: "input",
      label: "FAQs Answer (MS)",
      placeholder: "Enter FAQs Answer (MS)",
      // validation: { required: "FAQs Answer (MS) is required" },
    },
    {
      fieldName: "FAQs Answer (ZH)",
      fieldValue: "field_mandarin_faqs_answer",
      className: "col-span-6",
      type: "text",
      name: "field_mandarin_faqs_answer",
      formType: "input",
      label: "FAQs Answer (ZH)",
      placeholder: "Enter FAQs Answer (ZH)",
      // validation: { required: "FAQs Answer (ZH) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "field_faq_published",
      className: "col-span-12",
      type: "checkbox",
      name: "field_faq_published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Published",
    },
  ],
};
